export const LAYER_TYPES = [
  { id: "confirmed_dc", name: "Confirmed Data Centres", short: "Confirmed", color: "#0D9488", geometry: "point" },
  { id: "under_dev_dc", name: "Under Development", short: "Under Dev.", color: "#D97706", geometry: "point" },
  { id: "underwater_cables", name: "Underwater Cables", short: "Cables", color: "#2563EB", geometry: "line" },
  { id: "electricity_grid", name: "Electricity Grid", short: "Grid", color: "#E11D48", geometry: "line" },
  { id: "solar_systems", name: "Solar & Renewables", short: "Solar", color: "#16A34A", geometry: "point" },
];

export const TYPE_MAP = LAYER_TYPES.reduce((a, t) => ({ ...a, [t.id]: t }), {});

export const CATEGORIES = ["Commentary", "Infrastructure", "Connectivity", "Investigation", "Policy", "Community"];
export const INFRA_TYPES = ["Energy Demand", "Water & Cooling", "Connectivity", "Place & Planning", "Scale & Change", "Public Record"];
export const NZ_CENTER = [-41.0, 173.2];
